module.exports = __webpack_public_path__ + "static/media/hcfcd-logo.139b3201.png";